function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "settings_input_antenna_24px"
}, React.createElement("path", {
  id: "icon/action/settings_input_antenna_24px",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.04924 11.4037C1.6093 5.84375 6.29937 1.50375 11.9993 1.50375C17.6993 1.50375 22.3893 5.84375 22.9493 11.4037C23.0093 11.9937 22.5394 12.5038 21.9493 12.5038C21.4393 12.5038 21.0093 12.1237 20.9593 11.6237C20.5193 7.06375 16.6694 3.50375 11.9993 3.50375C7.32927 3.50375 3.4793 7.06375 3.03936 11.6237C2.98931 12.1237 2.55925 12.5038 2.04924 12.5038C1.45928 12.5038 0.999318 11.9937 1.04924 11.4037ZM11.9993 5.50375C8.51934 5.50375 5.62932 8.04376 5.08941 11.3737C4.98931 11.9637 5.4793 12.5038 6.08941 12.5038C6.5794 12.5038 6.98931 12.1438 7.06939 11.6537C7.4793 9.29376 9.52935 7.50375 11.9993 7.50375C14.4694 7.50375 16.5193 9.29376 16.9294 11.6537C17.0093 12.1438 17.4194 12.5038 17.9094 12.5038C18.5193 12.5038 18.9993 11.9637 18.8993 11.3737C18.3693 8.04376 15.4793 5.50375 11.9993 5.50375ZM12.9992 14.7938C14.0693 14.3138 14.7592 13.1338 14.4092 11.8037C14.1893 10.9937 13.5392 10.3337 12.7293 10.1038C11.0392 9.62375 9.4992 10.8838 9.4992 12.5038C9.4992 13.5237 10.1193 14.4037 10.9992 14.7938V18.0938L8.28923 20.7938C7.89922 21.1837 7.89922 21.8138 8.28923 22.2038C8.67925 22.5938 9.30925 22.5938 9.69927 22.2038L11.9992 19.9037L14.2992 22.2038C14.6893 22.5938 15.3193 22.5938 15.7093 22.2038C16.0993 21.8138 16.0993 21.1837 15.7093 20.7938L12.9992 18.0938V14.7938Z",
  fill: "black",
  fillOpacity: 0.54
}));

var SvgMenaraPantau = function SvgMenaraPantau(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenaraPantau, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menara_pantau.a669d083.svg";
export { ForwardRef as ReactComponent };